import React from "react";

const defaultState = {
    party_code:102,
    party_name:'',
    showPager:{
        dashboard:false
    }
}

const GlobalStateContext  = React.createContext(defaultState);

const GlobalDispatchContext = React.createContext();

function GlobalReducer(state,action) {
    switch (action.type) {
        case 'setCustomerID': {
            return {customerID: state.customerID} ;
        }
        case 'getCustomerID': {
            return state ;
        } 
        default:{

        }
    }
}

function GlobalProvider({children}) {
    const [state, dispatch ] = React.useReducer(GlobalReducer,defaultState);
    return (
        <GlobalStateContext.Provider value={state}>
            <GlobalDispatchContext.Provider value={dispatch}>
                {children}
            </GlobalDispatchContext.Provider>
        </GlobalStateContext.Provider>
    )
}

function useGlobalState() {
    const context = React.useContext(GlobalStateContext)
    if (context === undefined) {
        throw new Error('useglobalState must be used within a global Provider');
    }
    return context;
}

function useGlobalDispatch() {
    const context = React.useContext(GlobalDispatchContext);
    if (context === undefined) {
        throw new Error('useglobalDispatch must be used within a globalProvider');
    }
    return context
}

export {GlobalProvider, useGlobalState, useGlobalDispatch};